import React from "react";
import { Link } from "react-router-dom";

/**
 * Two-line premium wordmark:
 *   AYDINLAR              (Playfair Display Black, black)
 *   GLOBAL SİGORTA        (uppercase, gold, wide tracking)
 * Optional gold hairline between lines for premium feel.
 * size: "sm" (sidebar) | "md" (header, portal) | "lg" (login) | "xl" (footer)
 */
const SIZES = {
  sm: { top: "text-lg md:text-xl", bot: "text-[9px] md:text-[10px]", tracking: "tracking-[0.34em]", gap: "mt-1" },
  md: { top: "text-2xl md:text-3xl", bot: "text-[10px] md:text-xs", tracking: "tracking-[0.38em]", gap: "mt-1" },
  lg: { top: "text-3xl md:text-4xl lg:text-5xl", bot: "text-xs md:text-sm", tracking: "tracking-[0.42em]", gap: "mt-1.5" },
  xl: { top: "text-4xl md:text-5xl lg:text-6xl", bot: "text-sm md:text-base", tracking: "tracking-[0.5em]", gap: "mt-2" },
};

export default function Wordmark({ size = "md", to = "/", asLink = true, className = "", testid = "brand-wordmark", tone = "dark" }) {
  const s = SIZES[size] || SIZES.md;
  const topColor = tone === "light" ? "#ffffff" : "#000000";
  const botColor = tone === "light" ? "rgba(255,255,255,0.85)" : "var(--asg-primary-dark)";

  const inner = (
    <div className={`brand-wordmark inline-flex flex-col items-center leading-none select-none ${className}`} data-testid={testid}>
      <span
        className={`font-heading font-black uppercase ${s.top}`}
        style={{ color: topColor, letterSpacing: "-0.015em", fontFamily: `"Playfair Display", serif` }}
      >
        Aydınlar
      </span>
      <span
        className={`uppercase font-semibold whitespace-nowrap ${s.bot} ${s.tracking} ${s.gap}`}
        style={{ color: botColor }}
      >
        Global Sigorta
      </span>
    </div>
  );

  if (!asLink) return inner;
  return (
    <Link to={to} className="inline-flex items-center" data-testid={`${testid}-link`}>
      {inner}
    </Link>
  );
}
